module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h35"
  }, [_c('a', {
    attrs: {
      "id": "ch01lev01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0010-02.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("GETTING HERE")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Qo’noS is located in the Klinzhai Star System and is the center of the Klingon Empire. The planet features a single landmass, which boasts a variety of rugged terrain that might be considered uninviting to all but the hardiest of offworlders. Though Qo’noS accepts visitors throughout most of its calendar year, travelers are advised to be aware of various celebrations and cultural observances, including several that are off-limits to non-Klingons. For more details, consult your travel guide or one of the many visitor assistance centers located around the planet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When planning your trip, don’t forget that Qo’noS is but one planet within the Empire. We understand it’s likely to be the focal point of any vacation in Klingon territory, but be sure to take advantage of the various side trip opportunities. Imperial rule extends to more than thirty worlds, spread over a dozen star systems. A few of these planets were initially uninhabited and were used to establish colonies or military installations, while others belonged to civilizations subjugated by Klingon invasion. Despite its reputation for ruthlessness, the Klingon Empire and the worlds that it comprises are very carefully overseen. It has been more than two centuries since a conquered world or system has attempted to resist imperial governance, as most of these societies see the benefit of continued association with their rulers. As a result, each of these planets has their own set of Klingon-centric holidays and other cultural observances. Access to these regions is subject to change depending on the time of year, so plan accordingly!")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-01.jpg"
    }
  })])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01lev02"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("USING THIS GUIDE")])])]), _c('a', {
    attrs: {
      "id": "ch01lev02"
    }
  }, [_c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many of the names for commercial establishments featured in this guide are rendered in native "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("plqaD,")]), _vm._v(" or “Klingonese,” although a few of the merchants contacted for inclusion in this guide grudgingly agreed to provide appropriate translations or their own tourist-friendly alternatives. However, don’t expect Klingon signage to be accommodating to offworlders who don’t speak the lingo. If you can’t decipher the signs when searching for a specific location, you can always consult a visitor assistance center or simply access the planet’s global positioning satellite network.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "ch01lev02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('div', {
    staticClass: "boxch1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "boxh"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01lev03"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("TIPS FOR A FUN TRIP")])])]), _c('a', {
    attrs: {
      "id": "ch01lev03"
    }
  }, [_c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('p', {
    staticClass: "bnoindent"
  }, [_vm._v("• Here’s a secret: Qo’noS is beautiful, especially once you get away from the cities. Though it has suffered over generations from overpopulation, resource shortages, and natural calamity, significant portions of the planet harbor a breathtaking beauty that rivals anything you might find elsewhere in the quadrant. Whatever you do, make sure you take time for at least one overnight excursion away from the cities and into the wilderness. Sleep under the stars in the foothills surrounding the Lake of Lusor or in the boundless forests of the Ketha Lowlands. On clear nights in these areas, larger fragments from the Praxis asteroid belt are visible to the naked eye, and pieces of the destroyed moon occasionally make planet fall.")]), _vm._v(" "), _c('p', {
    staticClass: "bnoindent"
  }, [_vm._v("• Unless you are traversing areas that are accessible only via air or water vehicles, travel over land whenever possible and appropriate. While shuttles and transporters are available in the First City and other major population centers, don’t bypass a chance to behold the planet’s natural and often harsh beauty from as close a vantage point as possible. Magnetic-rail transports connect most major destinations, with plenty of landmarks and other points of interest to see along the way, but if you’ve got the time, opt for the historic rail lines, which still utilize wheeled trains powered by gas turbines. Constructed centuries ago using conscripted labor from subjugated worlds, these rail lines are preserved in order to connect travelers to a network of historic sites such as battlefields, shrines, village remnants, and natural formations. These include Kri’stak Volcano and Kang’s Summit, which aren’t accessible on the more modern, direct routes. Despite their age, the rail lines are kept in prime working order, in defiance of repeated calls to replace them with modern technology.")])]), _c('p', {
    staticClass: "bnoindent"
  }, [_c('a', {
    attrs: {
      "id": "ch01lev03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("• Due to the tilt of its axis, Qo’noS is routinely subjected to a broad spectrum of weather and climate extremes. Add to this the high levels of constant volcanic activity and the effects of prolonged industrialization, and don’t be surprised if you find yourself dealing with massive storms or sudden, severe shifts in temperature. Those touring the planet without benefit of a group or guide should check ahead at any destination and be prepared for weather delays and cancellations.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "bnoindent"
  }, [_vm._v("• Though Qo’noS is Class M and therefore capable of supporting most humanoid life-forms, the high concentrations of methane and other pollutants may make breathing difficult for certain species. Despite decades of terraforming to reduce the levels of atmospheric contamination, some areas of the planet will be either deemed off-limits, or only accessible through the use of environmental suits or other breathing equipment. Travelers with respiratory ailments are strongly urged to avoid these regions.")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-01.jpg"
    }
  })])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01lev04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("WHAT TO WEAR")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Qo’noS experiences a wide range of weather, with the planet’s landmass, or “supercontinent,” spanning multiple climate zones. However, conditions in the major population centers and main points of tourist interest tend toward the mild to warm side. Travelers seeking adventure away from these areas should be prepared to deal with sudden weather changes. Dress or be ready to replicate clothing that’s appropriate for a variety of situations, especially when considering outdoor activities. Durable, comfortable footwear suitable for prolonged walking and leisure hiking is a must. Conservative dress is encouraged in the outlying areas that have not yet adapted to the more cosmopolitan attitudes of the larger cities. When you are hiking in the jungles, bright-colored clothing may prove useful if you become lost or separated from your tour group. On the other hand, bright colors also tend to attract large predators such as saber bears and brush devils. The basic rule of thumb is “dress for dinner, not as dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With respect to local fashion or style, Klingons generally don’t subscribe to fads or trends. Most people associate Klingon fashion with military uniforms and accessories, and it’s true that soldiers of the Empire do treat their attire with particular reverence. While civilian clothing worn for work or other day-to-day activities tends toward utilitarian garments designed with durability and protection in mind, Klingons spare no effort when it comes to dressing for formal occasions of every stripe. Handcrafted from leather, silk, and other fabrics, vibrantly colored gowns and robes that accentuate the unique Klingon physiology are a common sight.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0014-01.jpg"
    }
  })])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01lev05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-02.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("LODGING TIPS")])])]), _c('a', {
    attrs: {
      "id": "ch01lev05"
    }
  }, [_c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You’ll find a broad assortment of guest lodging options, especially in the larger cities, from hotels and cottages established with offworlders in mind, to gatehouse-type quarters or camping areas, and other venues with varying levels of comfort that carry a more traditional local appeal. Klingons take pride in not pampering themselves, even while sleeping, so, when staying outside major cities, be prepared to recline on hard, flat rock, or metal surfaces. In contrast, Quin’lat, Krennla, and the First City in particular offer more welcoming accommodations for numerous species from throughout the Beta and Alpha Quadrants. Just don’t expect the sort of options you’d find at a more typical Federation vacation destination. When venturing away from the major population centers to the Ketha Lowlands or the Central Plains for any extended period, consider including a comfortable sleeping bag or other bedding with your luggage. Some merchants in these areas will sell or rent these items, but be forewarned that the selection will vary from place to place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the exception of those hotels operated in the larger cities by offworlders, Klingon accommodations tend to be staffed by natives rather than the wide array of species you might find working in hotels on other planets such as Vulcan or Andor. Reservations for scheduled tour groups are almost always honored, but accommodating Klingon travelers will always take precedence over catering to offworlders traveling independently. This is most definitely the case in smaller towns and remote provinces. Klingon merchants and proprietors tend to be brusque if not outright rude, and most interactions with them and their staff will be short and to the point.")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch01lev05"
    }
  }), _c('a', {
    attrs: {
      "id": "ch01lev06"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("ETIQUETTE")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The concept of honor is irrevocably woven into every facet of Klingon culture. It’s a keystone of their civilization, dating back to the time of Kahless the Unforgettable. According to history and mythology, Kahless all but single-handedly forged what would become the Klingon Empire, founding it upon the principles of honor and duty, with a warrior ethos that persists to this day. The name Kahless is spoken with reverence across the planet, from the lowliest soldier to the leaders of every Great House and family.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Though visitors are becoming more welcome on Qo’noS, especially in the larger population centers, travelers may still encounter some wariness toward offworlders, especially from older Klingons and in those regions that are less traveled. When traveling, bear in mind that, with few exceptions, Klingons value adherence to tradition and a wide range of ceremonial rituals. Many of these customs have become familiar to offworlders thanks to centuries of contact between Klingons and other species, but some practices remain closely guarded from outside eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Failing to acknowledge or respect a particular observance can be considered a grievous insult not just to an individual but even that person’s entire family and—depending on the specific offense—Klingon society as a whole. In extreme cases, it’s entirely possible for wayward travelers to find themselves inadvertently challenged to a fight simply because they have spoken in too soft a voice or stood too far away while conversing.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-02.jpg"
    }
  })])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0017-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indentt"
  }, [_vm._v("Patient and inquisitive travelers with a genuine desire to learn will find that many Klingons are more than willing to impart knowledge on these topics. If you get the chance, enjoy a meal with locals and share in the fellowship that comes from such gatherings. You will hear stories. You will sing songs, and you will celebrate all that it means to be Klingon. Many locals, especially in more rural areas, tend to be late-night revelers. Be ready to listen to off-key renditions of various drinking songs that last into the wee hours. There will also be fighting, as no Klingon drinking establishment can be considered respectable without a good brawl breaking out at least once a night. There may even be the occasional duel to the death, so don’t be surprised to see "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("d’k tahg")]), _vm._v(" knife play breaking out in the streets when a challenge is made.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarch1"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0017-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "side-head"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("AUTHOR’S NOTE:")])]), _vm._v(" "), _c('p', {
    staticClass: "side-noindent"
  }, [_vm._v("Various flavors of bloodwine are a perennial favorite of many Klingons but might be too potent for some offworlders. On the other hand, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("warnog")]), _vm._v(" beer and a number of ales might be more to your liking. Please drink responsibly.")])])]), _c('div', {
    staticClass: "boxch1"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('p', {
    staticClass: "side-head1"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("DID YOU KNOW?")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "side-headc"
  }, [_vm._v("SAYING “HELLO” AND “GOOD-BYE” ON QO’NOS")]), _vm._v(" "), _c('p', {
    staticClass: "side-noindentm"
  }, [_vm._v("It’s true that "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("tlhIngan Hol,")]), _vm._v(" just one of many varieties of spoken language that fall under the label “Klingonese,” is difficult to learn, and offworlders can spend years becoming proficient. Mastery is a matter of some debate, particularly when considering the hundreds of dialect variations that have been recorded over the course of Klingon history. While most outsiders tend to rely on universal translators to cover the language gap, Klingons will usually appreciate sincere efforts to communicate using their native tongue. Travelers can often make do with a few key terms and phrases and a little practice.")]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0018-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "side-indentm"
  }, [_vm._v("While Klingon hotel staff can be brusque when it comes to most interactions with outsiders, it’s fair to say their demeanor is warm and welcoming compared to that of the majority of Klingons you might encounter. For example, offering thanks to a shopkeeper for goods and services is liable to get you a dismissive shrug. Even simple greetings are often met with similar ambivalence. To put this in context, the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("tlhIngan Hol")]), _vm._v(" word for “hello” is "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("nuqneH")]), _vm._v(", which roughly means, “What do you want?” For offworlders, direct or even blunt interactions are always your best bet.")]), _vm._v(" "), _c('p', {
    staticClass: "side-indentm"
  }, [_vm._v("On the other hand, Klingons can be quite energetic when exchanging greetings with one another. For males in particular, it’s not unusual to see them hitting each other on the arms or even exchanging hearty embraces. If they’ve been drinking, don’t be surprised to see a headbutt or two. This isn’t any sort of formally recognized greeting, of course, but it’s still quite the sight when two lumbering, inebriated warriors address one another in this fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "side-indentmb"
  }, [_vm._v("Unless your skull is a strong as a Klingon’s, we advise against engaging in such salutations.")])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('p', {
    staticClass: "images"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0019-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0019-02.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b37b63b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01aa.vue
// module id = 72
// module chunks = 0